<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div></div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @changeSwitch="changeSwitch" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../../components/Button/ButtonAdd'
  import InputSearch from '../../../../components/Input/InputSearch'
  import TableMain from '../../../../components/Table/TableMain'
  import {api} from '../../../api/ConfigManagement'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {nSuccess} from '../../../../utils/notice'
  import {bus} from '../../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSearch,
      ButtonAdd,
      Breadcrumb},
    name: 'config-management',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧消息',
          name: 'message-template-manage'
        }, {
          value: '消息推送配置'
        }],
        searchPlaceholder: '消息类型',
        searchKey: '',
        deleteTipInfo: '是否确认删除该账号？',
        tableHead: [{
          prop: 'name',
          label: '消息类型'
        }, {
          prop: 'statusOnPage',
          label: '是否启用',
          active: '是',
          inactive: '否',
          isSwitch: true
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        operationArr: ['modify']
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    methods: {
      getPage () {
        this.$axios.post(api.gePage, {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          searchKey: this.searchKey
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              this.total = res.data.data.total
              data.map(v => {
                if (v.status === '0') {
                  v.statusOnPage = true
                } else {
                  v.statusOnPage = false
                }
              })
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      search (v) {
        this.pageNum = 1
        this.searchKey = v
        this.getPage()
      },

      changeSwitch (data) {
        this.$confirm('是否确认修改启用状态？', '提示')
          .then(() => {
            if (data.statusOnPage) {
              data.status = '1'
            } else {
              data.status = '0'
            }
            for (let i in data) {
              if (data[i] === '--') {
                data[i] = ''
              }
            }
            this.$axios.post(api.saveOrUpdate, data)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(errorHandler('修改失败'))
          })
          .catch(() => {
            this.getPage()
          })
      },
      // 修改
      goToModifyPage (code) {
        this.$router.push({
          path: `/config_modify/${code}`
        })
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/MessagePush/configManagement.vue